export const environment = {
  production: true,
  apiUrl: 'https://api.spaceagelabs.com.sg/v1/user',
  apiUrlV2: 'https://api.spaceagelabs.com.sg/v2',
  apiUrlV3: 'https://api.spaceagelabs.com.sg/v3',
  TRACKING_CODE : 'G-62379E6T34'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts